import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { RackThumb } from './RackThumb';
import { useRackSection } from './useRackSection';

// One rack beside the rail's stat block, so it is drawn a little smaller than the
// workbench section's (11px/U): a 42U rack is 420px, about the stat block's height.
const U_PX = 10;

/** The compact rack for the live rail (A/B trial against the workbench Rack section,
 *  2026-10-04): a single rack, with a pager to cycle through the others. Same layout
 *  source and same drawing as the section; clicking it opens Rack View. */
export function RackRail() {
  const s = useRackSection(1);
  const rack = s.visible[0];
  if (!rack) return null;

  return (
    <div data-testid="rack-rail" className="flex w-[108px] shrink-0 flex-col gap-1">
      <span className="text-center font-body text-tiny text-ink-muted">
        {s.paged ? `Rack ${rack.index + 1} of ${s.total}` : `Rack ${rack.index + 1}`}
      </span>
      <RackThumb rack={rack} uPx={U_PX} framed={s.framed} vendorId={s.vendorId}
        photographic={s.isPhotographic} onOpen={s.openRackView} testId="rack-rail" />
      {s.paged && (
        <div role="group" aria-label="Rack pages" className="flex items-center justify-between">
          <button type="button" aria-label="Previous rack" disabled={!s.canPrev} onClick={s.onPrev} className={PAGER}>
            <ChevronLeft className="h-4 w-4" />
          </button>
          <button type="button" aria-label="Next rack" disabled={!s.canNext} onClick={s.onNext} className={PAGER}>
            <ChevronRight className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  );
}

const PAGER = 'rounded-[var(--radius-2)] border border-hairline/30 p-1 text-ink hover:bg-surface-high focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand/60 disabled:opacity-40 disabled:hover:bg-transparent';
